import React from "react";
import About from "../../Components/About/About";
import Contact from "../../Components/Contact/Contact";
import Home from "../../Components/Home/Home";
import MyService from "../../Components/MyService/MyService";
import OtherSkills from "../../Components/OtherSkills/OtherSkills";
import Skill from "../../Components/Skill/Skill";
import Work from "../../Components/Work/Work";

const HomePage = () => {
  return (
    <>
      <Home />
      <About />
      <Skill />
      <OtherSkills />
      <MyService />
      <Work />
      <Contact />
    </>
  );
};

export default HomePage;
